module.exports = __webpack_public_path__ + "598b40e20b3beca779a118f395806f71.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/take_two_interactive_software_2022_chart.png
// module id = 1744
// module chunks = 0